<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '900px', maxWidth: '95vw' }"
  [baseZIndex]="10000000"
  styleClass="support-ticket-dialog"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <span class="material-symbols-outlined dialog-icon">support_agent</span>
        <div class="title-content">
          <h2>Richiesta Supporto</h2>
          <p class="title-subtitle">Compila il modulo per aprire un ticket di assistenza</p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="form-container">
      <!-- Nome ed Email sulla stessa riga -->
      <div class="form-row">
        <!-- Nome -->
        <div class="form-field form-field-half">
          <label for="customerName">
            Nome <span class="required">*</span>
          </label>
          <span class="p-input-icon-left" style="width: 100%;">
            <span class="material-symbols-outlined input-icon">person</span>
            <input
              id="customerName"
              type="text"
              pInputText
              [(ngModel)]="customerName"
              placeholder="Inserisci il tuo nome"
              [style]="{ width: '100%', paddingLeft: '2.5rem' }"
            />
          </span>
        </div>

        <!-- Email -->
        <div class="form-field form-field-half">
          <label for="customerEmail">
            Email <span class="required">*</span>
          </label>
          <span class="p-input-icon-left" style="width: 100%;">
            <span class="material-symbols-outlined input-icon">mail</span>
            <input
              id="customerEmail"
              type="email"
              pInputText
              [(ngModel)]="customerEmail"
              placeholder="Inserisci la tua email"
              [style]="{ width: '100%', paddingLeft: '2.5rem' }"
            />
          </span>
        </div>
      </div>

      <!-- Oggetto -->
      <div class="form-field">
        <label for="subject">
          Oggetto <span class="required">*</span>
        </label>
        <span class="p-input-icon-left" style="width: 100%;">
          <span class="material-symbols-outlined input-icon">subject</span>
          <input
            id="subject"
            type="text"
            pInputText
            [(ngModel)]="subject"
            placeholder="Inserisci l'oggetto del ticket"
            [style]="{ width: '100%', paddingLeft: '2.5rem' }"
          />
        </span>
      </div>

      <!-- Messaggio -->
      <div class="form-field">
        <label for="message">
          Messaggio <span class="required">*</span>
        </label>
        <textarea
          id="message"
          pInputTextarea
          [(ngModel)]="message"
          placeholder="Descrivi il problema o la richiesta in dettaglio..."
          [rows]="4"
          [style]="{ width: '100%', resize: 'vertical', minHeight: '80px' }"
        ></textarea>
       <!--  <small class="p-help-text">
          Fornisci quanti più dettagli possibili per aiutarci a risolvere il problema
        </small> -->
      </div>

      <!-- Allegati -->
      <div class="form-field">
        <label for="attachments">
          Allegati <span class="optional">(opzionale)</span>
        </label>
        <p-fileUpload
          #fileUpload
          mode="advanced"
          [multiple]="true"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [maxFileSize]="maxFileSize"
          chooseLabel="Scegli File"
          chooseIcon="pi pi-paperclip"
          (onSelect)="onFileSelect($event)"
          [style]="{ width: '100%' }"
          [auto]="false"
        >
          <ng-template pTemplate="content">
            <div class="attachments-list" *ngIf="attachments.length > 0">
              <div class="attachment-item" *ngFor="let file of attachments; let i = index">
                <span class="material-symbols-outlined file-icon">{{ getFileIcon(file.name) }}</span>
                <div class="file-info">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">{{ formatFileSize(file.size) }}</span>
                </div>
                <button
                  pButton
                  type="button"
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger p-button-sm"
                  (click)="removeAttachment(i)"
                ></button>
              </div>
            </div>
            <div class="no-attachments" *ngIf="attachments.length === 0">
              <span class="material-symbols-outlined">cloud_upload</span>
              <p>Nessun file selezionato</p>
            </div>
          </ng-template>
        </p-fileUpload>
<!--         <small class="p-help-text">
          Dimensione massima per file: 10MB. Formati supportati: immagini, PDF, documenti Office, archivi ZIP
        </small> -->
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="close()"
        [disabled]="sendingTicket"
      ></button>
      <button
        pButton
        type="button"
        label="Invia Ticket"
        icon="pi pi-send"
        [disabled]="!isFormValid() || sendingTicket"
        [loading]="sendingTicket"
        (click)="send()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
